import { z } from "zod";
import { uuid } from "./common";

/* Legal holds, retention review and custom booking domains (Phase 8e). */

/** Code-enforced floor for keeping dental records (owner decision D12 confirms the clinic's own number). */
export const MIN_RETENTION_YEARS = 3;

export const patientHoldInput = z.object({ patientId: uuid, reason: z.string().trim().min(3).max(500) });
export const releaseHoldInput = z.object({ reason: z.string().trim().min(3).max(500) });
export interface LegalHoldView {
  id: string;
  patientId: string;
  patientName: string;
  patientCode: string;
  reason: string;
  placedBy: string;
  placedAt: string;
  releasedAt: string | null;
  releasedBy: string | null;
  releaseReason: string | null;
}

export const retentionPolicyInput = z.object({
  retainYears: z.number().int().min(MIN_RETENTION_YEARS).max(100),
  action: z.enum(["archive", "anonymize"]),
  legalBasis: z.string().trim().max(500).nullish().transform((v) => v || null),
  isActive: z.boolean().default(true),
});
export interface RetentionPolicyView {
  retainYears: number;
  action: "archive" | "anonymize";
  legalBasis: string | null;
  isActive: boolean;
}
export interface RetentionCandidate {
  patientId: string;
  patientCode: string;
  fullName: string;
  lastActivity: string;
  archived: boolean;
}
export const retentionApplyInput = z.object({
  patientIds: z.array(uuid).min(1).max(500),
  /** The person confirms they reviewed the list. */
  confirm: z.literal(true, "Confirm that you reviewed the list"),
});

export const domainInput = z.object({
  hostname: z
    .string()
    .trim()
    .toLowerCase()
    .max(253)
    .regex(/^([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/, "Use a host name like book.yourclinic.in"),
});
export interface DomainView {
  id: string;
  hostname: string;
  status: "pending_verification" | "verified" | "active" | "failed" | "disabled";
  tlsStatus: "pending" | "issued" | "failed" | "expired";
  /** The TXT record the clinic adds at its DNS provider. */
  txtName: string;
  txtValue: string;
  verifiedAt: string | null;
  lastCheckedAt: string | null;
  lastError: string | null;
}
export const platformDomainInput = z.object({ status: z.enum(["active", "disabled", "verified"]), tlsStatus: z.enum(["pending", "issued", "failed", "expired"]).optional() });
